import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowCircleDown, ArrowCircleUp, CalendarMonth, Comment, LocalAtm, } from "@mui/icons-material";
import { clientConfigFn } from "clientConfig";
const getIcon = (icon, style) => {
    const config = clientConfigFn();
    const iconStyle = {
        fontSize: "large",
        marginRight: "1rem",
    };
    switch (icon) {
        case "balance":
            return _jsx(LocalAtm, { style: iconStyle });
        case "date":
            return _jsx(CalendarMonth, { style: iconStyle });
        case "credit":
            return config.showTransactionsAsLender ? (_jsx(ArrowCircleDown, { style: iconStyle, sx: { color: style } })) : (_jsx(ArrowCircleUp, { style: iconStyle, sx: { color: style } }));
        case "debit":
            return config.showTransactionsAsLender ? (_jsx(ArrowCircleUp, { style: iconStyle, sx: { color: style } })) : (_jsx(ArrowCircleDown, { style: iconStyle, sx: { color: style } }));
        case "description":
            return _jsx(Comment, { style: iconStyle });
        default:
            return null;
    }
};
const TransactionPageIcon = ({ iconName, style }) => {
    const config = clientConfigFn();
    const icon = getIcon(iconName, style);
    if (!config.showIconsTransactionPage || icon == null) {
        return null;
    }
    return icon;
};
export default TransactionPageIcon;
